import { motion } from "framer-motion";

interface TaglineProps {
  text?: string;
  subtext?: string;
  linkText?: string;
  linkHref?: string;
  variant?: "default" | "ecole" | "liceo";
}

export function Tagline({
  text = "A tutor that knows you better every day.",
  subtext,
  linkText,
  linkHref,
  variant = "default",
}: TaglineProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.15, duration: 0.35 }}
      className="pointer-events-none relative z-50 flex min-w-0 flex-col items-start gap-0.5"
    >
      <p
        className={`text-xs leading-5 text-white/70 lg:text-sm ${
          variant !== "default"
            ? "max-w-[24rem] whitespace-normal text-balance"
            : "max-w-[22rem] truncate"
        }`}
      >
        <span
          className={`font-medium ${variant !== "default" ? "text-school-soft/85" : "text-white/70"}`}
        >
          {text}
        </span>
      </p>
      {(subtext || linkText) && (
        <p className="text-[11px] font-medium text-white/55">
          {subtext ? `${subtext} ` : null}
          {linkText && linkHref ? (
            <a
              href={linkHref}
              target="_blank"
              rel="noopener noreferrer"
              className={`pointer-events-auto underline decoration-orange-200/30 underline-offset-2 transition-colors ${
                variant !== "default"
                  ? "text-school-soft/80 decoration-school-accent/30 hover:text-school-soft-hover"
                  : "text-orange-200/75 hover:text-orange-100"
              }`}
            >
              {linkText}
            </a>
          ) : null}
        </p>
      )}
    </motion.div>
  );
}
